import { useEffect } from 'react';
export function useClickOutside(ref, handler, id) {
    useEffect(function () {
        function handleClickOutside(event) {
            var clickedElement = event.target;
            if (ref.current && !ref.current.contains(event.target) && !clickedElement.closest("#".concat(id))) {
                handler();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, handler]);
}
